<script>
	import Country from '$lib/Components/Forms/Country/Country.svelte';
	import SuperForm from '$lib/Components/Forms/SuperForm/SuperForm.svelte';
	import SuperInput from '$lib/Components/Forms/SuperInput/SuperInput.svelte';
	import leadSchema from '$lib/PageSections/Forms/schemas/lead.schema.js';

	let {
		className = null,
		data = null,
		// eslint-disable-next-line no-useless-assignment
		leadFormData = $bindable(),
		buttonText = 'Contact Us',
		action = '/forms/contact-us',
		text,
	} = $props();
</script>

<div class={className}>
	{#if text}
		<p class="text-left text-sm">
			{@render text?.()}
		</p>
	{/if}

	<SuperForm
		{data}
		{action}
		sendPixelEvents
		formName="contact-us"
		{buttonText}
		schema={leadSchema}
	>
		{#snippet children({ form, disabled })}
			<SuperInput
				{form}
				{disabled}
				name="firstName"
				label="First Name"
				autocomplete="given-name"
			/>
			<SuperInput
				{form}
				{disabled}
				name="lastName"
				label="Last Name"
				autocomplete="family-name"
				required
			/>

			<SuperInput
				{form}
				{disabled}
				type="email"
				name="email"
				label="Email"
				autocomplete="email"
				required
				class="col-span-full"
			/>
			<SuperInput
				{form}
				{disabled}
				name="phone"
				type="tel"
				label="Phone"
				autocomplete="tel"
				phoneCountry="US"
				class="col-span-full"
			/>
			<SuperInput
				{form}
				{disabled}
				name="postalCode"
				type="text"
				label="Zip / Postal Code"
				autocomplete="postal-code"
			/>
			<Country {form} {disabled} name="country" label="Country" />
			<SuperInput
				{form}
				name="inquiryType"
				type="select"
				label="Inquiry Type"
				options={[
					{
						value: 'Get An Estimate',
						label: 'Get An Estimate',
					},
					{
						value: 'Question About Fit / Compatibility',
						label: 'Question About Fit / Compatibility',
					},
					{
						value: 'Question About Performance',
						label: 'Question About Performance',
					},
					{
						value: 'Contractor Program',
						label: 'Contractor Program',
					},
					{ value: 'Other', label: 'Other (please specify)' },
				]}
				required
				class="col-span-full"
			/>
			<SuperInput
				{form}
				{disabled}
				name="notes"
				type="textarea"
				label="How can we help you? (optional)"
				class="col-span-full"
			/>
		{/snippet}
	</SuperForm>
</div>
